/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_form = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.onready = function() {

		/*
		Input listener
		*/
		$('.js-input').bindWithDelay('input paste keypress',function() {

			/*
			Update
			*/
			specific_form.updateInput(
				$(this)
			);

		},500);

		/*
		Checkbox
		*/
		$('.js-checkbox').on('click',function() {

			var _input_id			= $(this).data('id');
			var _form_type	 		= $(this).data('type');
			var _checkbox_type	 	= $(this).data('type');
			var _form_id 			= $('.js-' + _checkbox_type + '-id').val();

			var _case_id 			= $('.js-' + _form_type + '-id').val();

			var _input_value;

			specific_form.toggleCheckbox(
				$(this)
			);

			/*
			Preloader: Show
			*/
			specific_preloader.show();

			if($(this).hasClass('active')) {
				_input_value = 'yes';
			} else {
				_input_value = 'no';
			}

			/*
			Ajax
			*/
			$.ajax({
				url: globalUrl + '/a/a/input-update',
				type: "POST",
				data: {
					case_id		: _case_id,
					form_type 	: _form_type,
					type 		: _checkbox_type,
					input		: _input_id,
					value 		: _input_value
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				/*
				Preloader: Show
				*/
				specific_preloader.hide();
				
			})
			.always(function() {
			});


		});
		
	};

	/*
	Update *************************
	Update *************************
	Update *************************
	Update *************************
	*/
	this.updateInput = function(
		_this
	) {

		var _input_id	 	= $(_this).data('id');
		var _form_type	 	= $(_this).data('type');
		var _input_value 	= $(_this).val();

		var _case_id 	= $('.js-' + _form_type + '-id').val();

		/*
		Preloader: Show
		*/
		specific_preloader.show();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/input-update',
			type: "POST",
			data: {
				case_id			: _case_id,
				input			: _input_id,
				form_type 		: _form_type,
				value			: _input_value
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Preloader: Show
			*/
			specific_preloader.hide();
			
		})
		.always(function() {
		});


	};

	/*
	Toggle *************************
	Toggle *************************
	Toggle *************************
	Toggle *************************
	*/
	this.toggleCheckbox = function(
		_this
	) {

		/*
		Toggle
		*/
		if(
			$(_this).hasClass('active')
		) {
			$(_this).removeClass('active');
		} else {
			$(_this).addClass('active');
		}
		

	};
		
}).apply(specific_form); 